// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Beausite-Classic-Trial-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/Beausite-Classic-Trial-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/Beausite-Classic-Trial-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/Beausite-Classic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/fonts/Beausite-Classic-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/fonts/Beausite-Classic-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/fonts/Beausite-Classic-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/fonts/Beausite-Classic-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/fonts/Beausite-Classic-Medium.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "BeausiteClassic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:
          url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("ttf"),
          url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
          url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 300;
  font-display: swap;
}

@font-face {
  font-family: "BeausiteClassic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src:
          url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("ttf"),
          url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
          url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "BeausiteClassic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src:
          url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("ttf"),
          url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"),
          url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff");
  font-weight: 500;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "BeausiteClassic", 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,4CAAyD;EACzD;;;gEAG4E;EAC5E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,4CAAsD;EACtD;;;gEAG0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,4CAAqD;EACrD;;;gEAGyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,4DAA4D;EAC5D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb","sourcesContent":["@font-face {\n  font-family: \"BeausiteClassic\";\n  src: url(\"/public/fonts/Beausite-Classic-Trial-Thin.ttf\");\n  src:\n          url(\"/public/fonts/Beausite-Classic-Trial-Thin.ttf\") format(\"ttf\"),\n          url(\"/public/fonts/Beausite-Classic-Trial-Thin.woff2\") format(\"woff2\"),\n          url(\"/public/fonts/Beausite-Classic-Trial-Thin.woff\") format(\"woff\");\n  font-weight: 300;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"BeausiteClassic\";\n  src: url(\"/public/fonts/Beausite-Classic-Regular.ttf\");\n  src:\n          url(\"/public/fonts/Beausite-Classic-Regular.ttf\") format(\"ttf\"),\n          url(\"/public/fonts/Beausite-Classic-Regular.woff\") format(\"woff2\"),\n          url(\"/public/fonts/Beausite-Classic-Regular.woff2\") format(\"woff\");\n  font-weight: 400;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"BeausiteClassic\";\n  src: url(\"/public/fonts/Beausite-Classic-Medium.ttf\");\n  src:\n          url(\"/public/fonts/Beausite-Classic-Medium.ttf\") format(\"ttf\"),\n          url(\"/public/fonts/Beausite-Classic-Medium.woff\") format(\"woff2\"),\n          url(\"/public/fonts/Beausite-Classic-Medium.woff2\") format(\"woff\");\n  font-weight: 500;\n  font-display: swap;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"BeausiteClassic\", 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
